import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

const ReelProgress = forwardRef(({ handleSeek }, ref) => {
  return (
    <div className="w-100 position-absolute bottom-0 start-0 end-0" style={{ zIndex: 1111, padding: '0px 0' }}>
      <input
        ref={ref}
        type="range"
        min="0"
        max="100"
        defaultValue={0}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation()
          handleSeek(e.target.value)
        }}
        className="reel-progressbar"
      />
    </div>
  )
})

ReelProgress.displayName = 'ReelProgress'

ReelProgress.propTypes = {
  handleSeek: PropTypes.func
}

export default ReelProgress
